import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Latest Races ")
const _hoisted_3 = {
  href: "https://docs.houndrace.com/houndrace-docs/gameplay/race-simulation",
  target: "_blank"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_info_icon = _resolveComponent("info-icon")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_icon_wrapper = _resolveComponent("n-icon-wrapper")!
  const _component_n_h3 = _resolveComponent("n-h3")!
  const _component_carousel_prev = _resolveComponent("carousel-prev")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_carousel_next = _resolveComponent("carousel-next")!
  const _component_live_card = _resolveComponent("live-card")!
  const _component_n_gi = _resolveComponent("n-gi")!
  const _component_n_grid = _resolveComponent("n-grid")!
  const _component_n_carousel = _resolveComponent("n-carousel")!

  return (_ctx.slideRaces.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_n_h3, {
          class: "thick-text",
          style: {"padding-left":"1.5rem"}
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            _createElementVNode("a", _hoisted_3, [
              _createVNode(_component_n_icon_wrapper, {
                "border-radius": "100%",
                size: "14",
                style: {"margin-left":".1rem","background":"transparent","border":"1px solid white"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_n_icon, {
                    color: "white",
                    size: "10"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_info_icon)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_n_carousel, {
          class: "live-races-carousel",
          "show-arrow": true
        }, {
          arrow: _withCtx(({ prev, next }) => [
            _createVNode(_component_n_button, {
              tertiary: "",
              circle: "",
              onClick: prev,
              style: {"position":"absolute","left":".5rem","top":"45%"},
              size: "large"
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_n_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_carousel_prev, { style: {"color":"var(--n-arrow-color)"} })
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_n_button, {
              tertiary: "",
              circle: "",
              onClick: next,
              style: {"position":"absolute","right":".5rem","top":"45%"},
              size: "large"
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_n_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_carousel_next, { style: {"color":"var(--n-arrow-color)"} })
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slideRaces, (races, i) => {
              return (_openBlock(), _createBlock(_component_n_grid, {
                "x-gap": "24",
                cols: "12",
                "item-responsive": "",
                responsive: "screen",
                collapsed: "",
                key: i
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(races, (race, auxIndex) => {
                    return (_openBlock(), _createBlock(_component_n_gi, {
                      key: race?.id,
                      span: _ctx.cardSpan
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_live_card, {
                          liveRace: race,
                          auxIndex: auxIndex
                        }, null, 8, ["liveRace", "auxIndex"])
                      ]),
                      _: 2
                    }, 1032, ["span"]))
                  }), 128))
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}